module.exports = __webpack_public_path__ + "static/media/card-gator-protect-mobile-es.68993f55.png";